import { useContext } from "react";
import PropTypes from "prop-types";
import { GlobalContext } from "../contextProvider/ContextProvider";
import { data as en } from "./en/data";
import { data as es } from "./es/data";
import { data as ru } from "./ru/data";
import { data as zh } from "./zh/data";

/**
 * Get current language
 * @name GetLang
 * @returns {string}
 */
export const GetLang = () => {
    const { state } = useContext(GlobalContext);
    const { lang } = state || {};

    return lang || "en";
};

export const gradeTranslator = (grade) => {
    switch (grade) {
        case "PRE":
        case "C3":
        case "C4":
        case "C5":
        case "CF":
        case "CF4":
        case "CF5":
        case "CH5":
        case "CP3":
        case "CP4":
        case "CP5":
        case "I1":
        case "I2":
        case "I3":
        case "P3":
        case "P4":
        case "P5":
        case "PK":
        case "UH5":
        case "UP4":
        case "UP5":
            return "PRE";
        case "K":
        case "0F":
        case "0H":
        case "00":
            return "K";
        case "FIRST":
        case "01":
            return "01";
        case "SECOND":
        case "02":
            return "02";
        case "THIRD":
        case "03":
            return "03";
        case "FOURTH":
        case "04":
            return "04";
        case "FIFTH":
        case "05":
            return "05";
        case "SIXTH":
        case "06":
            return "06";
        case "SEVENTH":
        case "07":
            return "07";
        case "EIGHTH":
        case "08":
            return "08";
        case "NINTH":
        case "09":
            return "09";
        case "TENTH":
        case "10":
            return "10";
        case "ELEVENTH":
        case "11":
            return "11";
        case "TWELFTH":
        case "12":
            return "12";
        default:
            return "-";
    }
};

/**
 * Translator engine - use context unless a langStr is provided
 * @name T
 * @param {string} key
 * @param {string | null} langStr
 * @returns {string}
 * @constructor
 */
const T = ({ key, langStr }) => {
    let myLang = langStr;
    if (!langStr) {
        myLang = GetLang();
    }

    switch (myLang) {
        case "en":
            if (en[key]) {
                return en[key];
            }
            break;
        case "es":
            if (es[key]) {
                return es[key];
            }
            break;
        case "ru":
            if (ru[key]) {
                return ru[key];
            }
            break;
        case "zh":
            if (zh[key]) {
                return zh[key];
            }
            break;
        default:
            break;
    }

    return en[key] ? en[key] : key;
};

T.propTypes = {
    key: PropTypes.string,
    langStr: PropTypes.string
};

T.defaultProps = {
    key: null,
    langStr: ""
};

export default T;
